const initMobileMenu = () => {
   const header = document.querySelector(".header");

   if (header) {
      const burgerButton = header.querySelector("[data-burger]");
      
      burgerButton?.addEventListener("click", () => {
         header.classList.toggle("is-open");
      })
   }
};

export default initMobileMenu;
